export enum TipoOperacion {
    Request,
    Response,
    AsyncEvent,
    Error
}
